import Select from 'react-select';

export default function AddItemsToGroup({
                                            label,
                                            name,
                                            options = [],
                                            selected,
                                            setSelected,
                                            setValue,          // ← receive from RHF
                                            errors
                                        }) {
    const mapped = options.map((o) => ({
        value: o._id,
        label: o.name || `${o.machine_name} (${o.kiosk_external_id})`
    }));

    return (
        <div className="mb-3">
            <label className="form-label fw-light">{label}</label>
            <Select
                isMulti
                options={mapped}
                value={selected}
                onChange={(vals) => {
                    setSelected(vals);                     // update chip list
                    setValue(name, vals.map(v => v.value)); // tell RHF the array
                }}
                classNamePrefix="react-select"
                placeholder={`Select ${label.toLowerCase()}…`}
            />

            {errors[name] && (
                <div className="invalid-feedback d-block">
                    {errors[name].message}
                </div>
            )}
        </div>
    );
}
